/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Local forage db wrapper for storing cached data
 */
import lf from 'localforage';

const dbs: any = {};
const config = {};

function getDB(dbName: any) {
  let result = dbs[dbName];
  if (!result) {
    result = dbs[dbName] = lf.createInstance({ ...config, name: dbName });
  }
  return result;
}

/**
 * Get Item from DB
 * @param key {string} item key
 * @param dbName {string} DB Name
 * @returns {Promise<string>} Resolved value
 */
export async function getItem(key: any, dbName = 'default') {
  const result = await getDB(dbName).getItem(key);
  if (!result) {
    return null;
  }
  const { value } = result;
  return value;
}

export async function setItem(key: any, value: any, dbName = 'default') {
  return await getDB(dbName).setItem(key, {
    value,
    lastUpdated: new Date().toISOString()
  });
}

export async function removeItem(key: any, dbName = 'default') {
  return await getDB(dbName).removeItem(key);
}

export async function clear(dbName = 'default') {
  return await getDB(dbName).clear();
}

export async function length(dbName = 'default') {
  return await getDB(dbName).length();
}

export async function keys(dbName = 'default') {
  return await getDB(dbName).keys();
}

export async function iterate(iterateCallback: any, dbName = 'default') {
  await getDB(dbName).iterate((result: any, key: any, index: any) => {
    if (result) {
      iterateCallback(result.value, key, index);
    } else {
      iterateCallback(null);
    }
  });
}
